/**
 * @file: 立式货架
 * @author: xiaolong.huang@dmall.com
 */

import { Cube } from '../cube/core/cube';
import * as CubeTree from '../cubeTree/index';
import { StageEvent } from '../message/index';
import FrontCubeData from '../frontCubeData/index';
import Update from '../update/index';
import CodiSystem from '../codiSystem/index';
import CubeRegister from '../cubeRegister';
import Interaction from '../interaction/index';
import DragSyStem from '../dragSyStem/index';
import Driver from '../driver/index';
import __Config__ from '../config/index';

function createShelf(shelfData: JsonData): void {
    let stageCube: CubeNode = new Cube(shelfData);

    // 初始化cube树操作对象
    CubeTree.init(stageCube);

    // 前端数据构建
    FrontCubeData.init(stageCube);

    // 强制触发一次层板布局算法
    Update.layerForceLayout();

    // cube渲染坐标收集
    CodiSystem.scanAllCubes();

    // 图纸渲染挂载流程
    stageCube.appendTo($('.J_LayoutStageMain'), () => {
        // 拖拽系统初始化
        DragSyStem.init(stageCube);

        // 交互功能初始化
        Interaction.init(stageCube);

        // 交互驱动接入
        Driver.init(stageCube);
    });

    // 更新器模块初始化
    Update.initMessage();

    setTimeout(() => {
        StageEvent.fire('setGlobalData', {
            eventFrom: 'stage',
            stageCube
        });
    }, 100);
}

export {
    createShelf
};
